import React, { Component, Suspense } from "react";
import { useGoogleLogin } from '@react-oauth/google';
import { UserAgentApplication } from "msal";
import { getUserDetails } from "./GraphService.jsx";
import axios from "axios";
import {
    Servicecalls
} from "./Functions.jsx";

import { useLinkedIn, LinkedIn } from 'react-linkedin-login-oauth2';
// You can use provided image shipped by this package or using your own
import linkedin from 'react-linkedin-login-oauth2/assets/linkedin.png';

const ELNurl = window.appUrl.ELN;
// const axios = require('axios');


const LinkedInApi = {
    clientId: '863mwqkv9hnwex',
    redirectUrl: `${window.location.origin}/linkedin`,
    oauthUrl: 'https://www.linkedin.com/oauth/v2/authorization?response_type=code',
    scope: 'profile,openid,email',
    state: '123456'
};

function Googlelogin(props) {

    const login = useGoogleLogin({
        onSuccess: async (response) => {
            try {
                const res = await axios.get(
                    "https://www.googleapis.com/oauth2/v3/userinfo",
                    {
                        headers: {
                            Authorization: `Bearer ${response.access_token}`,
                        }
                    }
                )
                console.log(res);
                let data = res.data;
                props.callbackonsuccess && props.callbackonsuccess(
                    {
                        username: data.name,
                        userfullname: data.name,
                        subcode: data.sub,
                        picture: data.picture,
                        emailid: data.email,
                        autenticatefrom: 1,
                        lockcount: 0,
                        loginfrom: 1,
                        userstatus: "A",
                        userretirestatus: 0
                    }
                );
            }
            catch (err) {

            }
        },
    });

    return (<button className="btn btn-flex login_btn btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
        onClick={() => login()}><img src="../images/googleicon.svg" /> </button>)
}

function Microsoftlogin(props) {
    const config = {
        auth: {
            authority:
                "https://login.microsoftonline.com/common",
            clientId: "62990499-6cde-4020-b0d3-97fbbe4b49f2",
            redirectUri: window.location.origin,
        },
        cache: {
            cacheLocation: "localStorage",
        },
        scopes: ["user.read"],
    };

    const userAgentApplication = new UserAgentApplication({
        auth: {
            clientId: config.auth.clientId,
            redirectUri: config.auth.redirectUri,
            authority: config.auth.authority,
        },
        cache: {
            cacheLocation: "localStorage",
            storeAuthStateInCookie: true,
        },
    });

    const microsoftlogin = async () => {
        try {
            // setLoginState({ isprogress: true });
            await userAgentApplication.loginPopup({
                scopes: config.scopes,
                prompt: "select_account",
            });
            await getUserProfile();
        } catch (err) {
            // parseanddispalyerror(err);
            // setLoginState({ isprogress: false });
        }
    };

    const getUserProfile = async () => {
        try {
            // Get the access token silently
            // If the cache contains a non-expired token, this function
            // will just return the cached token. Otherwise, it will
            // make a request to the Azure OAuth endpoint to get a token

            var accessToken = await userAgentApplication.acquireTokenSilent({
                scopes: config.scopes,
            });

            if (accessToken) {
                // Get the user's profile from Graph
                var user = await getUserDetails(accessToken);
                console.log(user);
                props.callbackonsuccess && props.callbackonsuccess(
                    {
                        username: user.displayName,
                        userfullname: user.displayName,
                        subcode: user.id,
                        picture: '',
                        emailid: user.mail,
                        autenticatefrom: 2,
                        lockcount: 0,
                        loginfrom: 1,
                        userstatus: "A",
                        userretirestatus: 0
                    }
                );

            }
        } catch (err) {
            parseanddispalyerror(err);

        }
    };

    const parseanddispalyerror = (err) => {
        var error = {};
        if (typeof err === "string") {
            var errParts = err.split("|");
            error =
                errParts.length > 1
                    ? { message: errParts[1], debug: errParts[0] }
                    : { message: err };
        } else {
            error = {
                message: err.message,
                debug: JSON.stringify(err),
            };
        }

        let errmsg = "";
        if (
            error.debug !== undefined &&
            error.debug !== null &&
            typeof error.debug === "string"
        ) {
            let objdebug = JSON.parse(error.debug);
            if (
                objdebug.errorCode !== undefined &&
                objdebug.errorCode === "endpoints_resolution_error"
            ) {
                // errmsg = state.organizationID + " is not a valid microsoft account";
            } else {
                errmsg = error.message;
            }
        } else {
            errmsg = error.message;
        }

        // props.alert.error(errmsg);
    };

    return (<button className="btn btn-flex login_btn btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
        onClick={() => microsoftlogin()} id="microsoft_btn" autoFocus={false}><img className="microsoftimg" src="../images/microsofticon.svg" /> </button>)
}

function Linkedinlogin(props) {
    console.log(window.location.origin);
    const { linkedInLogin } = useLinkedIn({
        clientId: '863mwqkv9hnwex',
        scope: 'profile,openid,email',
        redirectUri: `${window.location.origin}/linkedin`, // for Next.js, you can use `${typeof window === 'object' && window.location.origin}/linkedin`
        onSuccess: (code) => {
            try {

                let passobj = { code: code };

                Servicecalls("" + ELNurl + "/Restcall/getlinkedinuserprofile", passobj, (response) => {
                    let data = JSON.parse(response);
                    props.callbackonsuccess && props.callbackonsuccess(
                        {
                            username: data.name,
                            userfullname: data.name,
                            subcode: data.sub,
                            picture: data.picture,
                            emailid: data.email,
                            autenticatefrom: 3,
                            lockcount: 0,
                            loginfrom: 1,
                            userstatus: "A",
                            userretirestatus: 0
                        }
                    );
                }, () => { });

                // axios.post(ELNurl + "/Restcall/getlinkedinuserprofile", passobj
                // ).then(response => {
                //     console.log(JSON.parse(response.data));
                //     let data = JSON.parse(response.data);
                //     props.callbackonsuccess && props.callbackonsuccess(
                //         {
                //             username: data.name,
                //             userfullname: data.name,
                //             subcode: data.sub,
                //             picture: data.picture,
                //             emailid: data.email,
                //             autenticatefrom: 2,
                //             lockcount: 0,
                //             loginfrom: 1,
                //             userstatus: "A",
                //             userretirestatus: 0
                //         }
                //     );
                // }).catch((error) => { console.log(error) });


            }
            catch (err) {

            }
        },
        onError: (error) => {
            console.log(error);
        },
    });

    return (<button className="btn login_btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100" style={{ padding: 3 }}
        onClick={linkedInLogin}><img style={{ width: 27 }} src="../images/linkedinicon.svg" /> </button>)
}

class Linkedincustomlogin extends React.Component {
    initialState = {
        user: {},
        loggedIn: false
    };

    constructor(props) {
        super(props);
        this.state = this.initialState;
    }

    componentDidMount = () => {
        if (window.opener && window.opener !== window) {
            const code = this.getCodeFromWindowURL(window.location.href);
            window.opener.postMessage({ 'type': 'code', 'code': code }, '*')
            window.close();
        }
        window.addEventListener('message', this.handlePostMessage);
    };

    handlePostMessage = event => {
        if (event.data.type === 'code') {
            const { code } = event.data;
            try {

                let passobj = { code: code };
                axios.post(ELNurl + "/Restcall/getlinkedinuserprofile", passobj
                ).then(response => {
                    console.log(JSON.parse(response.data));
                    let data = JSON.parse(response.data);
                    this.props.callbackonsuccess && this.props.callbackonsuccess(
                        {
                            username: data.name,
                            userfullname: data.name,
                            subcode: data.sub,
                            picture: data.picture,
                            emailid: data.email,
                            autenticatefrom: 2,
                            lockcount: 0,
                            loginfrom: 1,
                            userstatus: "A",
                            userretirestatus: 0
                        }
                    );
                }).catch((error) => { console.log(error) });


            }
            catch (err) {

            }
        }
    };

    getCodeFromWindowURL = url => {
        const popupWindowURL = new URL(url);
        return popupWindowURL.searchParams.get("code");
    };

    showPopup = () => {
        const { clientId, redirectUrl, oauthUrl, scope, state } = LinkedInApi;
        const Url = `${oauthUrl}&client_id=${clientId}&scope=${scope}&redirect_uri=${redirectUrl}`;
        const width = 450,
            height = 730,
            left = window.screen.width / 2 - width / 2,
            top = window.screen.height / 2 - height / 2;
        window.open(
            Url,
            'Linkedin',
            'menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=' +
            width +
            ', height=' +
            height +
            ', top=' +
            top +
            ', left=' +
            left
        );
    };


    render() {

        return (
            <button className="btn login_btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100"
                onClick={this.showPopup}>Sign in with LinkedIn </button>
        )
    };
}

export { Googlelogin, Microsoftlogin, Linkedinlogin, Linkedincustomlogin }